import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ElementCaptureComponent } from '../element-capture/views/element-capture.component';

@Component({
    selector: 'app-capture-shell',
    imports: [CommonModule, ElementCaptureComponent],
    template: `<element-capture [functionalAreaId]="functionalAreaId" [scenarioId]="scenarioId"></element-capture>`
})
export class CaptureShellComponent implements OnInit, OnDestroy {
  functionalAreaId: string = '';
  scenarioId: string = '';

  constructor(private route: ActivatedRoute) {}
  
  async ngOnInit() {
    // Get route parameters - supports both feature and scenario capture routes
    this.route.params.subscribe(params => {
      // For feature capture: feature/capture/:featureId
      if (params['featureId']) {
        this.scenarioId = params['featureId'];
        this.functionalAreaId = ''; // No functional area for feature route
      }
      // For scenario capture: scenario/capture/:functionalAreaId/:scenarioId
      else if (params['functionalAreaId'] && params['scenarioId']) {
        this.functionalAreaId = params['functionalAreaId'];
        this.scenarioId = params['scenarioId'];
      }
    });
  }
  
  async ngOnDestroy() { 
    await window.host?.captureEnable(false); 
  }
}
